import { request } from '../request';
/**
 * 获取当前环境的appid
 */
export function getAppId() {
    var host = window.location.hostname;
    var appidFusionbankCN = 'wx56fffddd29305f2a';
    // 2021-05-08 uat 公众号切换到 fusionbankcn
    // const appidFusionbankHK = 'wx3970a1f34b0daea6';
    var appidFusionbank = 'wx9781c5df9e8fd2cd';
    var hostAppIdMap = {
        'www.infiniumbank.com': appidFusionbankCN,
        'u1www.infiniumbank.com': appidFusionbankCN,
        'u2www.infiniumbank.com': appidFusionbankCN,
        'u3www.infiniumbank.com': appidFusionbankCN,
        'u1website.infiniumbank.com': appidFusionbankCN,
        'u2website.infiniumbank.com': appidFusionbankCN,
        'u3website.infiniumbank.com': appidFusionbankCN,
        'www.fusionbank.com': appidFusionbank,
    };
    // @ts-ignore
    return hostAppIdMap[host];
}
/**
 * 获取sdk票据
 * @returns
 */
export var getJsTicket = function () {
    var appId = getAppId();
    return request("/node/security/weixin/jsticket?appId=".concat(appId));
};
/**
 * 地址协议与html统一
 * @param url
 * @returns
 */
export function conformProtocolWithLocation(url) {
    // 将输入的链接的协议换成当前页面的协议
    var urlObj = new URL(url);
    urlObj.protocol = window.location.protocol;
    return urlObj.toString();
}
